var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23.253px",
    height: "22.982px",
    viewBox: "0 0 23.253 22.982",
    enableBackground: "new 0 0 23.253 22.982",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808285",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    d: "M22.496,18.232c0,2.209-1.791,4-4,4h-2 c-2.209,0-4-1.791-4-4v-1.947c0-2.209,1.791-4,4-4h2c2.209,0,4,1.791,4,4V18.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808285",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    d: "M10.75,18.232c0,2.209-1.791,4-4,4h-2 c-2.209,0-4-1.791-4-4v-1.947c0-2.209,1.791-4,4-4h2c2.209,0,4,1.791,4,4V18.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808285",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    d: "M10.75,6.697c0,2.209-1.791,4-4,4h-2 c-2.209,0-4-1.791-4-4V4.75c0-2.209,1.791-4,4-4h2c2.209,0,4,1.791,4,4V6.697z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#808285",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    d: "M15.435,4.028 c0.69-1.438,1.609-2.031,2.788-1.807c1.191,0.227,1.84,1.061,1.979,2.506c0.343,0,0.692-0.053,1.017,0.01 c0.822,0.161,1.361,0.926,1.275,1.737c-0.087,0.831-0.775,1.457-1.621,1.459c-2.129,0.004-4.258,0.004-6.386,0 c-0.789-0.002-1.355-0.402-1.725-1.068c-0.383-0.688-0.342-1.383,0.064-2.059c0.514-0.856,1.613-1.133,2.366-0.85 C15.271,3.985,15.355,4.004,15.435,4.028z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardGray);
export default __webpack_public_path__ + "static/media/dashboardGray.dbbbcc912e5568225586cf233a6dbc35.svg";
export { ForwardRef as ReactComponent };